import { useEffect } from 'react'

import { Navigate, useParams } from 'react-router-dom'

import { REDIRECT_AFTER_SWITCH } from 'modals/OrderList/StartOrderModal/RetailerStartOrderModal/RetailerStartOrderModal.component'
import { ORDER_LIST } from 'routes/paths'

import OrderReview from './orderReview'

const ReviewPage = () => {
  const { id } = useParams<{ id: string }>()

  useEffect(() => {
    if (window.localStorage.getItem(REDIRECT_AFTER_SWITCH)) {
      window.localStorage.removeItem(REDIRECT_AFTER_SWITCH)
    }
  }, [])

  if (!id || ['undefined', 'null'].includes(id.toLowerCase().trim())) {
    return (
      <Navigate
        to={ORDER_LIST}
        state={{
          toastMessage: {
            type: 'info',
            title: 'Order not found',
            description: 'Please ensure that you have the correct URL.',
          },
        }}
      />
    )
  }

  return <OrderReview />
}

export default ReviewPage
